export const LISTAR_GRUPOS_CAPTURA = 'LISTAR_GRUPOS_CAPTURA'
export const LISTAR_GRUPO_CAPTURA_SELECIONADO = 'LISTAR_GRUPO_CAPTURA_SELECIONADO'
